(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-bestsellers"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.astonInitialized === 'true') return;

      const scroller = root.querySelector('[data-aston-scroller]');
      const track = root.querySelector('[data-aston-track]');
      const cards = root.querySelectorAll('[data-aston-card]');
      const control = root.querySelector('[data-aston-motion-control]');

      if (!scroller || !track || cards.length < 2) return;
      root.dataset.astonInitialized = 'true';

      const mobileQuery = window.matchMedia('(max-width: 749px)');
      const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      const autoplayEnabled = root.dataset.autoplay === 'true';
      const configuredSpeed = Number(root.dataset.speed) || 30;
      const pixelsPerFrame = configuredSpeed / 100;
      let direction = 1;
      let frameId;
      let userPaused = false;
      let interactionPaused = false;
      let visible = true;

      const canMove = () => (
        autoplayEnabled &&
        !mobileQuery.matches &&
        !reducedMotionQuery.matches &&
        !userPaused &&
        !interactionPaused &&
        visible
      );

      const updateControl = () => {
        if (!control) return;
        const paused = userPaused || reducedMotionQuery.matches;
        control.setAttribute('aria-pressed', String(paused));
        control.setAttribute('aria-label', paused ? 'Play product carousel' : 'Pause product carousel');
        control.querySelector('[data-aston-pause-label]').hidden = paused;
        control.querySelector('[data-aston-play-label]').hidden = !paused;
      };

      const updateTransforms = () => {
        if (mobileQuery.matches || reducedMotionQuery.matches) {
          cards.forEach((card) => card.style.removeProperty('transform'));
          return;
        }

        const scrollerRect = scroller.getBoundingClientRect();
        const center = scrollerRect.left + scrollerRect.width / 2;

        cards.forEach((card) => {
          if (card.matches(':hover') || card.matches(':focus-within')) return;
          const cardRect = card.getBoundingClientRect();
          const distance = ((cardRect.left + cardRect.width / 2) - center) / (scrollerRect.width / 2);
          const clamped = Math.max(-1, Math.min(1, distance));
          const rotateY = clamped * 14;
          const translateY = Math.abs(clamped) * 10;
          const scale = 1 - Math.abs(clamped) * 0.035;
          card.style.transform = `rotateY(${rotateY}deg) translateY(${translateY}px) scale(${scale})`;
        });
      };

      const animate = () => {
        if (canMove()) {
          const maxScroll = scroller.scrollWidth - scroller.clientWidth;
          scroller.scrollLeft += pixelsPerFrame * direction;

          if (scroller.scrollLeft >= maxScroll - 1) direction = -1;
          if (scroller.scrollLeft <= 1) direction = 1;
        }

        updateTransforms();
        frameId = window.requestAnimationFrame(animate);
      };

      const pauseForInteraction = () => {
        interactionPaused = true;
      };

      const resumeAfterInteraction = () => {
        interactionPaused = false;
      };

      control?.addEventListener('click', () => {
        userPaused = !userPaused;
        updateControl();
      });

      scroller.addEventListener('mouseenter', pauseForInteraction);
      scroller.addEventListener('mouseleave', resumeAfterInteraction);
      scroller.addEventListener('focusin', pauseForInteraction);
      scroller.addEventListener('focusout', resumeAfterInteraction);
      scroller.addEventListener('pointerdown', pauseForInteraction, { passive: true });
      scroller.addEventListener('pointerup', resumeAfterInteraction, { passive: true });
      scroller.addEventListener('scroll', updateTransforms, { passive: true });

      const observer = new IntersectionObserver((entries) => {
        visible = entries[0]?.isIntersecting ?? true;
      }, { threshold: 0.05 });
      observer.observe(root);

      const handlePreferenceChange = () => {
        updateControl();
        updateTransforms();
      };

      mobileQuery.addEventListener('change', handlePreferenceChange);
      reducedMotionQuery.addEventListener('change', handlePreferenceChange);

      root.addEventListener('shopify:section:unload', () => {
        window.cancelAnimationFrame(frameId);
        observer.disconnect();
      }, { once: true });

      updateControl();
      animate();
    };

    document.querySelectorAll('[data-aston-bestsellers]').forEach(initialize);

    document.addEventListener('shopify:section:load', (event) => {
      initialize(event.target.querySelector('[data-aston-bestsellers]'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
